import React from 'react'
import { Redirect } from 'react-router-dom'

const OrderEndPoint = ({ match: { params: { orderID } } }) => (
  <Redirect to={`/orders/${orderID}/pickup`}/>
)

export default OrderEndPoint
